import { Injectable } from "@angular/core";
import { FinancialBalance } from "../../models/domains/pbm/financial-satatement/financial-balance";
import { SalesOrderResult } from "../../models/domains/pbm/financial-satatement/sales-order-result";
import { FinancialStatementRepository } from "../../repositories/pbm/financial-statement.repository";
import { SearchFinancialStatement } from "../../models/domains/pbm/financial-satatement/search-financial-statement";

@Injectable({ providedIn: "root" })
export class FinancialStatementService {
  constructor(private financialStatementRepository: FinancialStatementRepository) {}

  public async findFinancialStatement(search: SearchFinancialStatement): Promise<SalesOrderResult[]> {
    return this.financialStatementRepository.findFinancialStatement(search);
  }

  public async findFinancialBalanceBySocialBalance(socialNumber: string, fiscalNumber:string): Promise<FinancialBalance> {
    return this.financialStatementRepository.findFinancialBalanceBySocialBalance(socialNumber, fiscalNumber);
  }
}
